import { clsx } from '@appvantageasia/core-utils';
import { LayoutSource } from '../types';
import MenuBar from './MenuBar';
import NotificationMessage from './NotificationMessage';
import Profile from './Profile';
import Logo from '@/components/blocks/Logo';
import useMediaQuery from '@/utils/useMediaQuery';

interface HeaderProps {
    collapsed: boolean;
    setCollapsed: (value: boolean) => void;
    hasNoSubMenu: boolean;
    source: LayoutSource;
}
const Header = ({ collapsed, setCollapsed, hasNoSubMenu, source }: HeaderProps) => {
    const isDesktop = useMediaQuery('(min-width: 1280px)');
    const isMobile = useMediaQuery('(min-width: 768px)');
    return (
        <header
            className={clsx('z-50', {
                'ltr:xl:ml-[300px] rtl:xl:mr-[300px]': !collapsed,
                'ltr:xl:ml-[72px] rtl:xl:mr-[72px]': collapsed || hasNoSubMenu,
                'sticky top-0': true,
            })}
        >
            <div className="bg-card/90 border-border w-full border-b px-[15px] py-3 backdrop-blur-lg md:px-6">
                <div className="flex h-full items-center justify-between">
                    <div className="flex items-center gap-3 md:gap-6">
                        {!isDesktop && isMobile && <Logo />}
                        <MenuBar noSubMenu={hasNoSubMenu} collapsed={collapsed} setCollapsed={setCollapsed} />
                    </div>
                    <div className="flex items-center gap-2">
                        {source === LayoutSource.Organization && <NotificationMessage />}
                        <div className="ltr:pl-2 rtl:pr-2">
                            <Profile />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
